import * as React from 'react';
import { Link, Route, RouteComponentProps, Switch } from 'react-router-dom';
import Breadcrumb from 'src/components/Breadcrumb';
import BreadcrumbItem from 'src/components/Breadcrumb/BreadcrumbItem';
import Wrapper from 'src/components/Wrapper';
import { AdminNewsProvider } from './Context';
import AdminNewsInitial from './Initial';
import AdminNewsSidebar from './Sidebar';
import AdminNewsCreate from './Create';
import AdminNewsEdit from './Edit';
import { ToastContainer } from 'src/components/Toast';

interface IAdminNewsParams {
  id?: string;
}

const AdminNews = ({ match }: RouteComponentProps<IAdminNewsParams>) => {
  const activeNewsItemId = React.useMemo(
    () => match.params.id ? parseInt(match.params.id, 10) : undefined,
    [match.params]
  );

  return (
    <AdminNewsProvider>
      <div className="has-background-gray-body pb-14">
        <Wrapper>
          <Breadcrumb className="pt3">
            <BreadcrumbItem>
              <Link to="/">Forside</Link>
            </BreadcrumbItem>
            <BreadcrumbItem active={true}>
              <Link to="">Nyheder</Link>
            </BreadcrumbItem>
          </Breadcrumb>

          <div>
            <h1 className="uppercase font-light text-lg my-5">
              Administrerer nyheder
            </h1>
            <div className="flex relative">
              <AdminNewsSidebar activeNewsItemId={activeNewsItemId} />
              <Switch>
                <Route path="/cms/nyheder" exact={true} component={AdminNewsInitial} />
                <Route path="/cms/nyheder/opret" exact={true} component={AdminNewsCreate} />
                <Route path="/cms/nyheder/:id" component={AdminNewsEdit} />
              </Switch>
              <ToastContainer />
            </div>
          </div>
        </Wrapper>
      </div>
    </AdminNewsProvider>
  );
};

export default AdminNews;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/AdminNews/index.tsx